import { TextCell } from '@med-fe/ui';
import { TemplateCell } from '../cell-components/TemplateCell';

export const templatesManagementColumns = [
  {
    title: '',
    dataIndex: 'template',
    key: 'select',
    width: 45,
    render: ({ assigned, id }, row, index) => (
      <input
        type='checkbox'
        value={id}
        checked={window.selectedKeys && window.selectedKeys.includes(row.key)}
        onChange={(e) => {
          if (window.setGridSelected) {
            window.setGridSelected(e.target.checked, row, index);
          }
        }}
      />
    ),
  },
  {
    title: 'Pattern Name',
    dataIndex: 'template',
    key: 'template',
    width: 250,
    render: ({ assigned, templateName, id }) => (
      <TemplateCell assigned={assigned} templateName={templateName} id={id} />
    ),
  },
  {
    title: 'Average Pace',
    dataIndex: 'performance',
    key: 'performance',
    width: 120,
    align: 'center',
    sorter: true,
    render: (value) => <TextCell value={value} strong />,
  },
  {
    title: 'First Exam',
    dataIndex: 'firstExamHours',
    key: 'firstExamHours',
    width: 95,
    sorter: true,
  },
  {
    title: 'Last Exam',
    dataIndex: 'lastExamHours',
    key: 'lastExamHours',
    width: 90,
    sorter: true,
  },
  {
    title: 'HOO Duration (In Hours)',
    dataIndex: 'templateHOODuration',
    key: 'templateHOODuration',
    width: 170,
    align: 'center',
    sorter: true,
    render: (value) => <TextCell value={value} strong />,
  },
  {
    title: 'Template duration (In Hours)',
    dataIndex: 'templateDuration',
    key: 'templateDuration',
    width: 170,
    align: 'center',
    sorter: true,
    render: (value) => <TextCell value={value} strong />,
  },
  {
    title: 'Creation Date',
    dataIndex: 'creationDate',
    key: 'date',
    sorter: true,
    width: 110,
  },
  {
    title: 'Clone Template',
    dataIndex: 'template',
    key: 'cloneTemplate',
    width: 100,
    render: ({ id }) => <TemplateCell assigned={false} templateName={'Clone'} id={id} isClone={true} />,
  },
  {}, // workaround to align columns
];
